import React from 'react';
import { connect } from 'react-redux';
import { getDisplayName } from 'shared/helpers/common';
import PropTypes from 'prop-types';
import snakeCaseKeys from 'snakecase-keys';
import { EVENT_TYPES, OBJECT_TYPES } from 'shared/constants/stats';
import API from 'shared/constants/api';
import { withFetch } from '../withFetch';

const dispatchEvent = (
  fetch,
  {
    event = EVENT_TYPES.VIEW,
    objectType = OBJECT_TYPES.ADVERT,
    objectId,
    transport,
    agency,
    author,
    userId,
    fingerprint,
    button,
  },
) =>
  fetch(API.STATS.BASE, {
    method: 'POST',
    body: JSON.stringify(
      snakeCaseKeys({
        event,
        button,
        objectType,
        objectId,
        ...(author ? { author } : {}),
        ...(userId ? { userId } : {}),
        ...(transport ? { transport } : {}),
        ...(fingerprint ? { fingerprint } : {}),
        ...(agency ? { agency } : {}),
      }),
    ),
  });

const withStatsEvents = WrappedComponent => {
  const Component = class extends React.Component {
    static displayName = `withStatsEvents(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      userId: PropTypes.number,
      fingerprint: PropTypes.string,
      isBot: PropTypes.bool.isRequired,
      fetch: PropTypes.func.isRequired,
    };
    static defaultProps = {
      userId: null,
      fingerprint: null,
    };

    events = {
      dispatchAdvertViewEvent: (id, authorID, transportId, agencyId, isSpare = false) => {
        const { userId, fingerprint, isBot } = this.props;

        if (authorID !== userId && !isBot) {
          dispatchEvent(this.props.fetch, {
            objectType: isSpare ? OBJECT_TYPES.SPARE_PART : OBJECT_TYPES.ADVERT,
            objectId: id,
            author: authorID,
            transport: transportId,
            agency: agencyId,
            userId,
            fingerprint,
          });
        }
      },

      dispatchPhoneViewEvent: (id, authorID, transportId, agencyId, isSpare = false) => {
        const { userId, fingerprint } = this.props;

        if (authorID !== userId) {
          dispatchEvent(this.props.fetch, {
            objectType: isSpare ? OBJECT_TYPES.SPARE_PART : OBJECT_TYPES.ADVERT,
            event: EVENT_TYPES.PHONE_CLICK,
            objectId: id,
            author: authorID,
            transport: transportId,
            agency: agencyId,
            userId,
            fingerprint,
          });
        }
      },

      dispatchDealerViewEvent: id => {
        const { userId, fingerprint, isBot } = this.props;

        if (id && !isBot) {
          dispatchEvent(this.props.fetch, {
            event: EVENT_TYPES.VIEW,
            objectId: id,
            objectType: 'agency',
            userId,
            fingerprint,
          });
        }
      },

      dispatchDealerRedirectEvent: id => {
        const { userId, fingerprint } = this.props;

        if (id) {
          dispatchEvent(this.props.fetch, {
            event: EVENT_TYPES.REDIRECT,
            objectId: id,
            objectType: 'agency',
            userId,
            fingerprint,
          });
        }
      },

      dispatchDealerShowPhoneEvent: id => {
        const { userId, fingerprint } = this.props;

        if (id) {
          dispatchEvent(this.props.fetch, {
            event: EVENT_TYPES.PHONE_CLICK,
            objectId: id,
            objectType: 'agency',
            userId,
            fingerprint,
          });
        }
      },

      dispatchDealerSignUp: id => {
        const { userId, fingerprint } = this.props;

        if (id) {
          dispatchEvent(this.props.fetch, {
            event: EVENT_TYPES.VIEW,
            objectId: id,
            objectType: 'agency',
            button: 'appointment',
            userId,
            fingerprint,
          });
        }
      },
    };

    render() {
      return <WrappedComponent events={this.events} {...this.props} />;
    }
  };

  const mapStateToProps = ({ user, globals, searchForm }) => ({
    userId: user.user.id,
    fingerprint: globals.fingerprint,
    isBot: globals.isBot,
    formVocabulary: searchForm.vocabulary,
    formData: searchForm.data,
    formState: searchForm.selected,
    formResults: searchForm && searchForm.results,
  });

  return connect(mapStateToProps)(withFetch(Component));
};

export default withStatsEvents;



// WEBPACK FOOTER //
// ./src/shared/hocs/stats/withStatsEvents.js